import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const RemoveFromLibraryIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2 4H0V18C0 19.1 0.9 20 2 20H16V18H2V4ZM18 0H6C4.9 0 4 0.9 4 2V14C4 15.1 4.9 16 6 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14H6V2H18V14ZM8 7H16V9H8V7Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default RemoveFromLibraryIcon;
